export const CLIENT_SMART_SEARCH_ARIA = {
  listboxId: "client-listbox",
  getOptionId: (highlightedIndex: number) => `client-item-${highlightedIndex}`,
};
